import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@material-ui/core';
import { ContentSpacer } from './generic-content-spacer';
import { AlignmentType } from '../../models/tcsm-block-models';

interface ButtonWrapperProps {
    flexEnd?: boolean,
    alignment?: AlignmentType | null,
}

const usestyles = makeStyles((theme) => ({
    buttonContainer: {
        '& > a , & > button': {
            marginRight: theme.spacing(.5),
            marginBottom: theme.spacing(.5),
        },
    },
}));


export const ButtonWrapper = (props: React.PropsWithChildren<ButtonWrapperProps>) => {
    const classes = usestyles();

    function ParseJustify(){
        if (props.alignment) {
            switch (props.alignment) {
                case AlignmentType.Left:
                    return 'flex-start';

                case AlignmentType.Center:
                    return 'center';
            
                case AlignmentType.Right:
                    default:
                    return 'flex-end';                    
            }
        }

        return props.flexEnd ? 'flex-end' : 'flex-start';
    }

    return (
        <div className='grid-main-content'>
            <ContentSpacer>
                <Grid data-testid="button-wrapper" container item xs={12} justifyContent={ParseJustify()} className={classes.buttonContainer} >
                    {props.children}
                </Grid>
            </ContentSpacer>
        </div>
    );
};

ButtonWrapper.defaultProps = {
    flexEnd: null,
    alignment: null,
};